"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moralis_1 = __importDefault(require("moralis"));
var react_1 = require("react");
var swr_1 = __importDefault(require("swr"));
var utils_1 = require("../../utils");
var useResolverPaginated = function (_a) {
    var endpoint = _a.endpoint, operation = _a.operation, request = _a.request, fetchParams = _a.fetchParams;
    var _b = (0, swr_1.default)([endpoint, request ? { operation: operation, request: operation.serializeRequest(request, moralis_1.default.Core) } : null], utils_1.fetcherPaginated, __assign({ revalidateOnFocus: false }, fetchParams)), data = _b.data, error = _b.error, mutate = _b.mutate, isValidating = _b.isValidating;
    var fetch = (0, react_1.useCallback)(function (params) {
        var fetchRequest = params !== null && params !== void 0 ? params : request;
        if (!fetchRequest) {
            throw new utils_1.NoHookParamsError('useEvmNativeBalance');
        }
        return mutate((0, utils_1.fetcherPaginated)(endpoint, {
            operation: operation,
            request: fetchRequest,
        }));
    }, []);
    return {
        data: data,
        error: error,
        fetch: fetch,
        isFetching: isValidating,
    };
};
exports.default = useResolverPaginated;
//# sourceMappingURL=useResolverPaginated.js.map